import { Tooltip } from 'ui/tooltip/Tooltip';
import { DateFormat, TimeFormat, localizeDateTime, localizeRelativeTimeSince } from 'utils/l10n';

export const RELATIVE_DATE_TEST_ID = 'relative-time-text';

type RelativeTimeProps = {
  isUnderlined?: boolean;
  /** The timestamp that it was last saved */
  timestamp?: string | number;
  tooltipIsEnabled?: boolean;
};

export const RelativeTime = ({
  isUnderlined = true,
  timestamp,
  tooltipIsEnabled = true,
  ...props
}: RelativeTimeProps) => {
  if (!timestamp) {
    return null;
  }

  const date = new Date(timestamp);
  const timeFromNow = localizeRelativeTimeSince(date);
  const dateToDisplay = localizeDateTime(date, {
    dateStyle: DateFormat.Short,
    showTime: true,
    timeStyle: TimeFormat.Locale,
  });

  return (
    <Tooltip
      data-test={RELATIVE_DATE_TEST_ID}
      isEnabled={tooltipIsEnabled}
      isUnderlined={isUnderlined}
      tooltipContent={<span data-test="relative-time-hover-text">{dateToDisplay}</span>}
      {...props}
    >
      {timeFromNow}
    </Tooltip>
  );
};
